export default __webpack_public_path__ + "static/media/requisiciones-compra.94b06b9d.png";